import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, AlertTriangle, Sunrise, Activity, Moon, Trophy } from 'lucide-react';
const chapters = [{
  icon: BookOpen,
  title: 'Capítulo 1: El Enemigo Silencioso',
  description: 'Entiende qué es el cortisol y cómo destruye tu salud sin que lo notes'
}, {
  icon: AlertTriangle,
  title: 'Capítulo 2: Los 5 Hábitos Que lo Disparan',
  description: 'Descubre qué estás haciendo cada día que empeora el problema'
}, {
  icon: Sunrise,
  title: 'Semana 1: Identificar y Preparar',
  description: 'Rutina matutina, registro del estrés y los 5 alimentos anti-cortisol'
}, {
  icon: Activity,
  title: 'Semana 2: Regular y Fortalecer',
  description: 'Técnicas de respiración, movimiento correcto y gestión mental'
}, {
  icon: Moon,
  title: 'Semana 3: Consolidar y Transformar',
  description: 'Sueño profundo, nutrición y conexiones que sanan'
}, {
  icon: Trophy,
  title: 'Plan de Mantenimiento',
  description: 'Los 7 pilares para sostener el equilibrio hormonal para siempre'
}];
export const WhatsInsideSection: React.FC = () => {
  return <section className="py-20 lg:py-28 bg-brand-cream" data-id="element-163">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-164">
        <motion.div className="text-center max-w-3xl mx-auto mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-165">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-charcoal" data-id="element-166">
            ¿Qué encontrarás en la guía?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-167">
          {chapters.map((chapter, index) => {
          const Icon = chapter.icon;
          return <motion.div key={index} className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1 border border-gray-100" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} data-id="element-168">
                <div className="w-12 h-12 bg-brand-lightmint rounded-xl flex items-center justify-center mb-6" data-id="element-169">
                  <Icon className="w-6 h-6 text-brand-emerald" data-id="element-170" />
                </div>
                <h3 className="text-xl font-bold text-brand-charcoal mb-3" data-id="element-171">
                  {chapter.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-172">
                  {chapter.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
};